import People from '@mui/icons-material/People';
import GenericButton from '../../components/GenericButton';
import { Typography } from '@mui/material';
import CustomerListSingleRow from './SingleRow';
import SingleRowContainer from '../../components/SingleRow';

const singleRowMapping = {
    customerList: (row) => <CustomerListSingleRow name={row.driver} address={row.city} topMetadata={row.businessName} />
};

export const renderButtons = (buttonConfigs) => {
    return buttonConfigs.map(({ key, icon, onClick }, index) => <GenericButton key={key || index} icon={icon} onClick={onClick} />);
};

export const renderSideSticky = ({ dataRef }) => {
    return (
        <>
            <span>
                <People />
            </span>
            <Typography fontWeight={500}>{dataRef.current}</Typography>
        </>
    );
};

export const renderSingleRow = (data, variant) => {
    return data.map((row, index) => (
        <SingleRowContainer key={index}>{singleRowMapping[variant]?.(row) || <p>שגיאה</p>}</SingleRowContainer>
    ));
};
